









































































import { SubEvent, Event } from 'inscreva-sse-models';
import { IziToast } from 'izitoast';
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';

import { TemplateOptions } from '@/models/template';

import { UiManagerService } from '../../services/UiManager';
import EventCardList from '../EventCardList.vue';
import toast from '../toast';
import { ToastType } from '../toast/tost-type.enum';

@Component({
  components: {
    EventCardList,
  },
})
export default class TalkComponent extends Vue {
  @Prop({ required: true })
  private event: Event;

  @Prop({ default: false })
  private isEditing: boolean;

  @Prop({ default: true })
  private scroll: boolean;

  private eventCardList: EventCardList;

  private templateOptions: TemplateOptions = {
    title: 'Palestra/Curso',
    subTitle: 'Palestrante',
  };

  mounted() {
    this.event.allowFavorite = this.event.allowFavorite ?? true;
    if (this.scroll) {
      UiManagerService.scrollTo('#talks');
    }
  }

  favorite(event: Event) {
    if (!this.event.extraFormData?.favorites) {
      this.event.extraFormData.favorites = [];
    }
    const index = this.event.extraFormData.favorites.findIndex((elm) => elm._id === event._id);
    const finalIndex = index !== -1 ? index : this.event.extraFormData.favorites.length;
    this.event.extraFormData.favorites.splice(finalIndex, 1, {
      _id: event._id,
      info: { name: event.info.name, price: event.info.price },
      parent: { _id: this.event._id },
    });
  }

  async onEditImage({ imageBase64, index }: { imageBase64: string; index: number }) {
    try {
      this.event.attachImage(imageBase64, index);
      toast('Imagem carregada', ToastType.SUCESS);
    } catch (err) {
      toast('Erro ao carregar imagem', ToastType.ERROR);
    }
  }

  deleteEvent(index: number) {
    window.location.hash = '';
    toast('', ToastType.QUESTION, {
      timeout: 12000,
      close: false,
      overlay: true,
      displayMode: 1,
      id: 'question',
      zindex: 999,
      title: 'Atenção!',
      message: 'Deseja realmente realizar a exclusão da palestra?',
      position: 'center',
      buttons: [
        [
          '<button type="button"><b>SIM</b></button>',
          (instance: IziToast, toast: HTMLDivElement) => {
            instance.hide({ transitionOut: 'fadeOut' }, toast, 'button');
            const newEvent = this.event;
            newEvent.subEvents.splice(index, 1);
            return this.onUpdate(newEvent);
          },
          true,
        ],
        [
          '<button type="button">NÃO</button>',
          (instance: IziToast, toast: HTMLDivElement) => {
            instance.hide({ transitionOut: 'fadeOut' }, toast, 'button');
          },
          false,
        ],
      ],
    });
  }

  toggleEvent(index: number): Event {
    const newEvent = this.event;
    newEvent.subEvents.splice(
      index,
      1,
      Object.assign(newEvent.subEvents[index], {
        hidden: (newEvent.subEvents[index] as any).hidden === false ? undefined : false,
      }),
    );
    UiManagerService.scrollTo(`#subEvent-${index}`);
    return this.onUpdate(newEvent);
  }

  confirmEvent() {
    UiManagerService.scrollTo(`#event-info`);
    return this.onUpdate(this.event);
  }

  @Emit()
  onUpdate(event: Event): Event {
    this.event = event;
    return event;
  }

  isSendSuggestionAllowed(subEvent: SubEvent): boolean {
    return subEvent.cardFields.some((cardField) => cardField.id.includes('sugestao'));
  }

  allowSendSuggestion(subEvent: SubEvent, index: number): Event {
    this.event.subEvents.splice(
      index,
      1,
      Object.assign(subEvent, {
        cardFields: [
          {
            description: {
              value: 'Se desejar, transmita ao Palestrante sua expectativa para a palestra',
              style: 'color: darlgoldenrod; font-weight: 600; margin: 2px;',
            },
            id: `sugestao_${index}`,
            name: `sugestao_${index}`,
            label: `Sugestao evento ${index}`,
            type: 'field',
            text: 'Suas expectativas',
          },
        ],
      }),
    );
    return this.onUpdate(this.event);
  }

  get subEventsDate() {
    return this.event.subEvents.map(({ info }) => info.date);
  }
}
